(function () {
  function init() {
    var menuButton = document.querySelector('.sk-menu-button');
    var mobileMenu = document.getElementById('sk-mobile-menu');
    if (menuButton && mobileMenu) {
      menuButton.addEventListener('click', function () {
        var open = menuButton.getAttribute('aria-expanded') === 'true';
        menuButton.setAttribute('aria-expanded', String(!open));
        mobileMenu.hidden = open;
        document.body.classList.toggle('sk-menu-open', !open);
      });
    }

    document.querySelectorAll('.sk-home').forEach(function (home) {
      var buttons = home.querySelectorAll('.sk-filter');
      var cards = home.querySelectorAll('.sk-product-card');
      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          var filter = button.dataset.filter;
          buttons.forEach(function (item) { item.classList.toggle('is-active', item === button); });
          cards.forEach(function (card) {
            card.hidden = filter !== 'all' && card.dataset.category !== filter;
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
